module.exports = __webpack_public_path__ + "img/old2.cbde1967.jpg";